<form (submit)="handleOnSubmit($event)" [formGroup]="form">
  <h2 mat-dialog-title>Clear monitoring</h2>

  <mat-dialog-content>
    <div formArrayName="inputs">
      @for (item of inputs.controls; track item; let i = $index) {
        <div class="mb-4 flex align-middle" [formGroupName]="i">
          <mat-form-field floatLabel="auto">
            <mat-label>{{ 'ID' | translate }}</mat-label>
            <input matInput formControlName="ID" type="number" />
          </mat-form-field>
          <button mat-icon-button class="ml-4 mt-4" (click)="deleteInput(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      }
    </div>

    <div class="mb-4">
      <button mat-raised-button (click)="addInput()">
        <mat-icon>add</mat-icon>
        {{ 'ADD' | translate }}
      </button>
    </div>
  </mat-dialog-content>

  <div mat-dialog-actions>
    <button mat-raised-button color="primary" type="submit">
      {{ 'CLEAR' | translate }}
    </button>
    <button mat-raised-button (click)="close()" type="button">
      {{ 'CANCEL' | translate }}
    </button>
  </div>
</form>
